import {
  SET_COMMENTS_STATUS,
  SET_COMMENTS_COURSE,
  SET_COMMENTS_LESSON
} from '@/store/mutation-types'

const changeSearchCommentsStatus = ({commit, dispatch}, payload) => {
  commit(SET_COMMENTS_STATUS, payload)
}
const changeSearchCommentsCourse = ({commit, dispatch}, payload) => {
  commit(SET_COMMENTS_COURSE, payload)
}
const changeSearchCommentsLesson = ({commit, dispatch}, payload) => {
  commit(SET_COMMENTS_LESSON, payload)
}

export default {
  changeSearchCommentsStatus,
  changeSearchCommentsCourse,
  changeSearchCommentsLesson
}



// WEBPACK FOOTER //
// ./src/components/comments/store/actions.js